import React from 'react';
import TemplateIcon from '@heroicons/react/outline/TemplateIcon.js';
import { BlockType } from '../../types/index.js';
import { ContainerBlock as Component } from './Block.js';
import { ContainerBlockSettings as Settings } from './Settings.js';
export const RegisteredContainerBlock = ({ $t, }) => ({
    recommendedName: 'Container',
    Component,
    config: {
        type: BlockType.Layout,
        usable: true,
        displayName: $t({
            id: 'Blocks.Container.DisplayName',
            defaultMessage: 'Container',
        }),
        Settings,
        Icon: React.createElement(TemplateIcon, null),
        acceptsChildren: true,
        defaultProps: {
            direction: 'vertical',
            spacing: 'md',
            padding: 'none',
            size: 'xl',
        },
        getContextAwareConfig: ({ props }) => ({
            description: `${props.size}, ${props.direction}`,
        }),
    },
});
const RegisteredDeprecatedLayouts = (intl) => (Object.assign(Object.assign({}, RegisteredContainerBlock(intl)), { config: Object.assign(Object.assign({}, RegisteredContainerBlock(intl).config), { usable: false, editable: true }) }));
export const RegisteredListBlock = (intl) => (Object.assign(Object.assign({}, RegisteredDeprecatedLayouts(intl)), { recommendedName: 'List' }));
export const RegisteredColumnsBlock = (intl) => (Object.assign(Object.assign({}, RegisteredDeprecatedLayouts(intl)), { recommendedName: 'Columns', config: Object.assign(Object.assign({}, RegisteredDeprecatedLayouts(intl).config), { editable: false, lockedChildren: true }) }));
//# sourceMappingURL=registered.js.map